var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.014,
    height: 29,
    viewBox: "0 0 31.014 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.014 87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-244.764 -90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.371,6.778a1.616,1.616,0,0,0-1.218-.556H8.889L8.575,4.347A1.611,1.611,0,0,0,6.986,3H3.361a1.611,1.611,0,0,0,0,3.222h2.26l3,17.986a1.4,1.4,0,0,0,.073.2,1.362,1.362,0,0,0,.087.243,1.582,1.582,0,0,0,.193.288,1.646,1.646,0,0,0,.153.18,1.548,1.548,0,0,0,.311.209,1.547,1.547,0,0,0,.18.1,1.563,1.563,0,0,0,.591.121H27.931a1.611,1.611,0,0,0,0-3.222H11.573l-.267-1.611H29.542a1.61,1.61,0,0,0,1.595-1.382L32.748,8.062A1.614,1.614,0,0,0,32.371,6.778ZM29.3,9.444l-.459,3.222H23.1V9.444Zm-7.809,0v3.222H16.653V9.444Zm0,4.833V17.5H16.653V14.278ZM15.042,9.444v3.222H10.208a.775.775,0,0,0-.238.048L9.425,9.444Zm-4.811,4.833h4.811V17.5H10.767ZM23.1,17.5V14.278H28.6L28.145,17.5Z",
    transform: "translate(0)",
    fill: "#0abf8c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.417,
    cy: 2.417,
    r: 2.417,
    transform: "translate(10.208 27.167)",
    fill: "#0abf8c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.417,
    cy: 2.417,
    r: 2.417,
    transform: "translate(24.708 27.167)",
    fill: "#0abf8c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4b21fdd186ee5266423116e8ff32c43b.svg";
export { ForwardRef as ReactComponent };